import { formatPhone, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PersonalInformation } from '../../../../../interfaces/PersonalInformation';
import { StyledLine } from './Phone.styles';

export interface PhoneProps {
  personalInfo: PersonalInformation;
}
const Phone: FC<PhoneProps> = ({ personalInfo }) => {
  const { t } = useTranslation('PersonalInformationsTile');
  const language: string = useScopedSelector('/language.locale');

  if (!personalInfo || !personalInfo.phones) return null;
  const home = Number(personalInfo.phones.home);
  const work = Number(personalInfo.phones.work);
  const cell = Number(personalInfo.phones.cell);
  const fax = Number(personalInfo.phones.fax);
  return (
    <>
      {personalInfo.phones.home && personalInfo.phones.home !== '' &&
        <StyledLine>
          <span>{t('phones.homePhoneLabel')}</span>
          {Number.isNaN(home) ? personalInfo.phones.home : formatPhone(home, { locale: language })}
        </StyledLine>}
      {personalInfo.phones.work && personalInfo.phones.work !== '' &&
        <StyledLine>
          <span>{t('phones.workPhoneLabel')}</span>
          {Number.isNaN(work) ? personalInfo.phones.work : formatPhone(work, { locale: language })}
          {personalInfo.phones.workExtension && personalInfo.phones.workExtension !== '' &&
            <span>{t('phones.extentionPhoneLabel')}</span>}
          {personalInfo.phones.workExtension}
        </StyledLine>}
      {personalInfo.phones.cell && personalInfo.phones.cell !== '' &&
        <StyledLine>
          <span>{t('phones.cellPhoneLabel')}</span>
          {Number.isNaN(cell) ? personalInfo.phones.cell : formatPhone(cell, { locale: language })}
        </StyledLine>}
      {personalInfo.phones.fax && personalInfo.phones.fax !== '' &&
        <StyledLine>
          <span>{t('phones.faxPhoneLabel')}</span>
          {Number.isNaN(fax) ? personalInfo.phones.fax : formatPhone(fax, { locale: language })}
        </StyledLine>}
    </>
  );
};
export default Phone;
